import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=c38bd12c&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=c38bd12c&prod&lang=scss&scoped=true"
import style1 from "./nav.vue?vue&type=style&index=1&id=c38bd12c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38bd12c",
  null
  
)

export default component.exports